import { CPF_MASK, CNPJ_MASK } from '@shared/models'
import { RoleDomainModelList } from '@shared/models/backend'

export const normalizeString = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export const getRole = (roleDescription: string) => {
  return RoleDomainModelList.find((role) => role.descricao === roleDescription)
}

export const getNewNomeOrCPFMask = (value: string, currentMask: string) => {
  if (!value) return ''

  const cleanedValue = value.replace(/\D/g, '') // Remove caracteres não numéricos

  let newMask = ''

  if (cleanedValue.length > 0 && cleanedValue.length <= 11) {
    newMask = CPF_MASK
  } else if (cleanedValue.length > 11 && cleanedValue.length <= 14) {
    newMask = CNPJ_MASK
  } else {
    newMask = ''
  }

  return newMask !== currentMask ? newMask : null // Retorna null se a máscara não mudou
}

export const downloadFile = (data: Blob, fileName: string) => {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(data)
  link.download = fileName
  link.click()
}
